// ----------------------------------------------------------------------

import { useActiveCompanyUser } from 'src/organization/hooks/useActiveCompanyUser';

type ReturnType = {
  isAdmin: boolean;
};

export const useAdminUser = (): ReturnType => {
  const { activeCompanyUser } = useActiveCompanyUser();

  return {
    isAdmin: Boolean(
      activeCompanyUser && activeCompanyUser.role === 'administrator'
    ),
  };
};
